import { Component, OnInit } from '@angular/core';
import { MasterService } from '../master.service';
@Component({
  selector: 'app-productactivationlistnew',
  templateUrl: './productactivationlistnew.component.html',
  styleUrls: ['./productactivationlistnew.component.scss']
})
export class ProductactivationlistnewComponent implements OnInit {

  ProductList=[];
  productarryalist = [];
  ischeck = true;
  schoolname;
  mobileno;
  serialno;
  activationkey;
  
  constructor(private service: MasterService) {

   
  }
  FilterRecord(schoolname,mobileno,serialno){
    this.productarryalist =[];
    this.ProductList = [];
    var school = schoolname==undefined?'':schoolname;
    var mobile = mobileno==undefined?'':mobileno;
    var serial = serialno==undefined?'':serialno;
    if(school== '' && mobile== '' && serial == ''){
      alert("Fill Atleast  One Field")
    }
    this.service.GetProductNotActivatedListNew(btoa(school).replace(/=+$/, ''), btoa(mobile).replace(/=+$/, ''), btoa(serial).replace(/=+$/, '')).subscribe((data: any) => {
      this.ProductList = data;

      data.forEach(element => {
        this.productarryalist.push(element.userid);
        element.actkey = true;
      });
    })

  }
  SelectAll(ischeck){
    
    if(ischeck == true){
      this.ProductList.map((obj)=>{
        obj.actkey = true;
        if(!this.productarryalist.includes(obj.userid)){
        this.productarryalist.push(obj.userid);
        }
      })
    }
    else{
      this.ProductList.map((obj)=>{
        obj.actkey = false;
        var loc = this.productarryalist.indexOf(obj)
        this.productarryalist.splice(loc, 1);
      })
    }
   
  }
  ngOnInit() {
  }
  CheckboxSelect(chcek, data) {

    if (chcek == true) {
      if(!this.productarryalist.includes(data.userid)){
        this.productarryalist.push(data.userid);
      }
      
    }
    else {
      var loc = this.productarryalist.indexOf(data.userid)
      this.productarryalist.splice(loc, 1);
    }



  }
  Apply(key: string) {
    if(key==undefined){
      alert("Select Any one below record and Fill Activation Key")
    }
    else{
      var upkey = key.toUpperCase();
     
      this.service.AddProductActivationKeyNew(this.productarryalist,upkey).subscribe((res:any)=>{
        if(res == "Success"){
          alert("Activation key Added Successfully");
          window.location.reload();
        }
        else{
          alert("Unable to add key");
          window.location.reload();
        }
      })
    }
  
  }
}
